<!--begin::Content container-->
<div id="kt_app_content_container" class="app-container py-5 container-fluid">
  <router-outlet></router-outlet>
</div>
